module.exports = __webpack_public_path__ + "img/35a1fe2.jpg";